import { formatCurrencyInputOnChangeWithoutDecimals } from '@fruitful/fruitils';
import type { FieldValues } from 'react-hook-form';
import { type BaseControlledProps, ControlledInput } from 'smoothie';

import { FormModuleContainer } from './FormModuleContainer';

interface AmountFormModuleProps<
    TFieldValues extends FieldValues,
    TContext,
> extends BaseControlledProps<TFieldValues, TContext> {
    title?: string;
    label?: string;
}

export const AmountFormModule = <TFieldValues extends FieldValues, TContext>({
    title = 'Amount',
    label = 'Monthly amount',
    name,
    control,
    register,
    errors,
}: AmountFormModuleProps<TFieldValues, TContext>) => {
    return (
        <FormModuleContainer title={title}>
            <ControlledInput
                name={name}
                control={control}
                register={register}
                errors={errors}
                label={label}
                size="tiny"
                fontWeight="regular"
                formatValueOnChange={formatCurrencyInputOnChangeWithoutDecimals}
            />
        </FormModuleContainer>
    );
};
